// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uRarTRK_mp8cDy {
  display: block;
  position: absolute;
  z-index: 0;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  transition: transform 85ms ease-in, opacity 85ms ease-in;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.uRarTRK_mp8cDy:hover {
  z-index: 1;
}
.uRarTRK_mp8cDy:hover .CtKMoInVMD9Wq8 .hsw8Pd_5LPDGK3 {
  display: block;
  top: var(--ds-space-negative-050, -4px);
  left: var(--ds-space-negative-050, -4px);
  width: 72px;
  height: 72px;
  border-radius: 10px;
  background-color: var(--ds-surface-raised-hovered, #f1f2f4);
}
/* Shadow for peel */
.CtKMoInVMD9Wq8 {
  position: relative;
}
.hsw8Pd_5LPDGK3,
.cZ0UzQ6Bp8qPZC,
.hlgwlQoR10Vmy9,
.VBC5IOrSH7lgfo,
.nFkiHf9AUNZCm5 {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  color: transparent;
}
.hsw8Pd_5LPDGK3:-moz-loading,
.cZ0UzQ6Bp8qPZC:-moz-loading,
.hlgwlQoR10Vmy9:-moz-loading,
.VBC5IOrSH7lgfo:-moz-loading,
.nFkiHf9AUNZCm5:-moz-loading {
  visibility: hidden;
}
.cZ0UzQ6Bp8qPZC {
  mask-repeat: no-repeat;
  mask-size: cover;
  opacity: 0.9;
}
.VBC5IOrSH7lgfo {
  clip: rect(0 64px 64px 64px);
  transform: scaleX(1) skewY(0deg);
  backface-visibility: hidden;
  transition: transform 0.3s ease, opacity 0.3s ease-in, clip 0.3s ease-in;
  opacity: 0;
  filter: brightness(0);
}
.hlgwlQoR10Vmy9 {
  clip: rect(0 64px 64px 0);
  transition: clip 0.3s ease-in;
}
.nFkiHf9AUNZCm5 {
  clip: rect(0 64px 64px 64px);
  transform: translateX(0) perspective(300px) rotateY(0deg) translateX(0);
  transform-style: preserve-3d;
  transition: transform 0.3s ease-in, filter 0.1s ease-in, clip 0.3s ease-in;
  filter: brightness(1);
}
.uRarTRK_mp8cDy.y6qinQqmfvB5H9 .CtKMoInVMD9Wq8 .hlgwlQoR10Vmy9 {
  clip: rect(0 16px 64px 0);
}
.uRarTRK_mp8cDy.y6qinQqmfvB5H9 .CtKMoInVMD9Wq8 .VBC5IOrSH7lgfo {
  clip: rect(0 64px 64px 16px);
  transform: scaleX(0.4) skewY(8deg);
  opacity: 0.2;
}
.uRarTRK_mp8cDy.y6qinQqmfvB5H9 .CtKMoInVMD9Wq8 .nFkiHf9AUNZCm5 {
  clip: rect(0 64px 64px 16px);
  transform: translateX(-16px) perspective(300px) rotateY(-70deg) translateX(16px);
  filter: brightness(1.2);
}
.WO8ocxfWkkDg8h {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  padding: var(--ds-space-050, 4px);
  border-radius: 50%;
  opacity: 0;
  background-color: var(--ds-background-input, #ffffff);
  line-height: 1em;
}
.WO8ocxfWkkDg8h:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
}
.WO8ocxfWkkDg8h:active {
  background-color: var(--ds-background-input-pressed, #ffffff);
}
.uRarTRK_mp8cDy:hover .WO8ocxfWkkDg8h {
  opacity: 1;
}
.L5AFvusPb7xD24 {
  transition: 0s z-index 0.3s step-start, 0s all 0.3s linear;
}
.uRarTRK_mp8cDy:hover .L5AFvusPb7xD24 {
  transition: 0s z-index 0.3s step-end, 0s all 0.3s linear;
}
.L5AFvusPb7xD24 .WO8ocxfWkkDg8h {
  transition: 0s z-index 0.3s step-end, 0s opacity 0.3s linear;
}
.uRarTRK_mp8cDy:hover .L5AFvusPb7xD24 .WO8ocxfWkkDg8h {
  transition: 0s z-index 0.3s step-start, opacity 0.3s linear;
  opacity: 1;
}
.L5AFvusPb7xD24 .hsw8Pd_5LPDGK3 {
  transition: 0s z-index 0.3s step-end, 0s all 0.3s linear;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sticker": `uRarTRK_mp8cDy`,
	"stickerRemoving": `CtKMoInVMD9Wq8`,
	"highlight": `hsw8Pd_5LPDGK3`,
	"residue": `cZ0UzQ6Bp8qPZC`,
	"fixed": `hlgwlQoR10Vmy9`,
	"shadow": `VBC5IOrSH7lgfo`,
	"peel": `nFkiHf9AUNZCm5`,
	"stickerPeeling": `y6qinQqmfvB5H9`,
	"removeStickerButton": `WO8ocxfWkkDg8h`,
	"cardBackSticker": `L5AFvusPb7xD24`
};
export default ___CSS_LOADER_EXPORT___;
